/* eslint-disable no-nested-ternary */
import {
  del,
  get,
  post,
  postFileAchievement,
  postVerifProfilStudent,
  put,
} from '@webapps/utils';
import axios from 'axios';

const { NX_REST_API, NX_PROXY_API } = process.env;

export const getInfosIndividual = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/${id}`,
    }),
  format: ({ data }) => data,
};

export const getInfosIndividualWithAffiliateStatus = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/affiliate_business_status/${id}`,
    }),
  format: ({ data }) => data,
};

export const getInfosAccount = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/accounts/${id}`,
    }),
  format: ({ data }) => data,
};

export const getInfosAccountRestricted = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/accounts/alt/${id}`,
    }),
  format: ({ data }) => data,
}

export const getSkillsLanguage = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/skills_language/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getHobbies = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/hobbies/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getSoftSkills = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/soft_skills/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getSoftwareSkills = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/software_skills/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getCodingSkills = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/coding_skills/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getTransports = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/transports/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getTrainings = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/trainings/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getBusinessById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/${id}`,
    }),
  format: ({ data }) => data,
};

export const getCertifications = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/certifications/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getAchievements = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/achievements/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getWorkExperience = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/work_experiences/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getProfilePresentation = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/profile/${id}`,
    }),
  format: ({ data }) => data,
};

export const getProfilePreferences = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/profile/preferences/${id}`,
    }),
  format: ({ data }) => data,
};

export const updateProfilePreferencesIndivudual = {
  query: ({ id, status, type }) =>
    put({
      url: `${NX_REST_API}/profile/preferences/individual/${id}/${type}?active=${status}`,
    }),
};

export const getMoyensTransport = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/transports/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getPermis = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/driving_licences/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const postStudentInterest = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/hobbies/owner/${id}`,
      data,
    }),
};

export const postStudentCompetencePerso = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/soft_skills/owner/${id}`,
      data,
    }),
};

export const postStudentCompetencePro = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/skills/owner/${id}`,
      data,
    }),
};

export const postManyStudentCompetencePro = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/skills/owner/${id}/bulk`,
      data,
    }),
};

export const deleteManyStudentCompetencePro = {
  query: ({ data, id }) => {
    del({
      url: `${NX_REST_API}/individual/module/skills/owner/${id}/bulk`,
      data: {
        data
      },
    })
  }
};

export const updateStudentCompetencePro = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/skills/${id}`,
      data,
    }),
};

export const updateStudentCertification = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/certifications/${id}`,
      data,
    }),
};

export const getAllInvitation = {
  query: ({ status, type, email }) =>
    get({
      url: `${NX_REST_API}/affiliates/invites?status=${status}&type=${type}&student=${email}`,
    }),
};

export const updateStudentCoordonnes = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/${id}`,
      data,
    }),
};

export const updateStudentFormation = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/trainings/${id}`,
      data,
    }),
};
export const updateStudentExperience = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/work_experiences/${id}`,
      data,
    }),
};

export const updateTransport = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/transports/owner/${id}?transports=${data}`,
    }),
};

export const deleteStudentCompetencePro = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/skills/${id}`,
    }),
};

export const deleteStudentSoftware = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/software_skills/${id}`,
    }),
};

export const deleteStudentAchievement = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/achievements/${id}`,
    }),
};

export const deleteStudentLangProg = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/coding_skills/${id}`,
    }),
};

export const deleteStudentLang = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/skills_language/${id}`,
    }),
};

export const deleteStudentPermis = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/driving_licences/${id}`,
    }),
};

export const deleteStudentCertification = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/certifications/${id}`,
    }),
};
export const deleteStudentFormation = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/trainings/${id}`,
    }),
};
export const deleteStudentExperience = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/work_experiences/${id}`,
    }),
};

export const deleteStudentCompPerso = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/soft_skills/${id}`,
    }),
};

export const deleteStudentHobby = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/individual/module/hobbies/${id}`,
    }),
};

export const postStudentLang = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/skills_language/owner/${id}`,
      data,
    }),
};

export const postStudentPermis = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/driving_licences/owner/${id}`,
      data,
    }),
};

export const postStudentLangPro = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/coding_skills/owner/${id}`,
      data,
    }),
};

export const postStudentSoftware = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/software_skills/owner/${id}`,
      data,
    }),
};

export const postStudentAchievement = {
  query: ({ data, id }) =>
    postFileAchievement({
      url: `${NX_REST_API}/individual/module/achievements/owner/${id}`,
      data,
    }),
};

export const studentVerifProfil = {
  query: ({ data, id }) =>
    postVerifProfilStudent({
      url: `${NX_REST_API}/accounts/verify/individual/${id}`,
      data,
    }),
};

export const postStudentFormation = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/trainings/owner/${id}`,
      data,
    }),
};

export const postStudentCertification = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/certifications/owner/${id}`,
      data,
    }),
};

export const postStudentExperience = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/individual/module/work_experiences/owner/${id}`,
      data,
    }),
};

export const getSkillCategory = {
  query: () =>
    get({
      url: `${NX_REST_API}/individual/module/skills_category?size=1000`,
    }),
  format: ({ data }) => data,
};

export const getStudentSkillsPro = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/skills/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getFormationById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/trainings/${id}`,
    }),
  format: ({ data }) => data,
};

export const getCertificationById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/certifications/${id}`,
    }),
  format: ({ data }) => data,
};

export const getEducationById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/work_experiences/${id}`,
    }),
  format: ({ data }) => data,
};

export const getCompetenceProById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/skills/${id}`,
    }),
  format: ({ data }) => data,
};

export const getStudentsCVTeque = {
  query: ({
    certifiedProfile,
    cities,
    freeStudent,
    goals,
    jobDomain,
    jobs,
    desiredContractLength,
    id,
    keyword,
    page,
    partners,
    size,
    trainingDegrees,
    trainingDomains,
    type,
  }) =>
    get({
      url: `${NX_REST_API}/individual/search/${type}/${id}?partners=${partners}&freeStudent=${freeStudent}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(cities ? { cities } : {}),
          ...(keyword ? { keyword } : {}),
          ...(trainingDegrees ? { trainingDegrees } : {}),
          ...(goals ? { goals } : {}),
          ...(jobDomain ? { jobDomain } : {}),
          ...(jobs ? { jobs } : {}),
          ...(desiredContractLength ? { desiredContractLength } : {}),
          ...(trainingDomains ? { trainingDomains } : {}),
          ...(certifiedProfile === true
            ? { certifiedProfile }
            : certifiedProfile === false
              ? { certifiedProfile: false }
              : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getStudentsCVTequeBusiness = {
  query: ({
    certifiedProfile,
    cities,
    goals,
    keyword,
    page,
    partners,
    size,
    trainingDegrees,
    trainingDomains,
  }) =>
    get({
      url: `${NX_REST_API}/individual/search/business?page=${page}&size=${size}`,
      options: {
        params: {
          ...(partners ? { partners } : {}),
          ...(cities ? { cities } : {}),
          ...(keyword ? { keyword } : {}),
          ...(trainingDegrees ? { trainingDegrees } : {}),
          ...(goals ? { goals } : {}),
          ...(trainingDomains ? { trainingDomains } : {}),
          ...(certifiedProfile ? { certifiedProfile } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const downloadCv = {
  query: ({ data }) =>
    post({
      url: `${NX_PROXY_API}/generate-pdf`,
      data,
      options: { responseType: "blob" },
    }),
  format: ({ data }) => data,
}

export const downloadStatement = {
  query: ({ data }) =>
    post({
      url: `${NX_PROXY_API}/generate-statement`,
      data,
      options: { responseType: "blob" },
    }),
  format: ({ data }) => data,
}

export const downloadPlanning = {
  query: ({ data }) =>
    post({
      url: `${NX_PROXY_API}/generate-planning`,
      data,
      options: { responseType: "blob" },
    }),
  format: ({ data }) => data,
}

export const updateProfileCompletion = {
  query: ({ id }) => 
    put({
      url: `${NX_REST_API}/individual/profileCompletion/${id}`,
    }),
};

export const updateDescriptionStudent = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/profile/update/presentation/${id}`,
      data,
    }),
};

export const savedTraining = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/trainings/module/saved_trainings`,
      data,
    }),
};

export const postuleTraining = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/trainings/module/applications`,
      data,
    }),
};

export const unSavedTraining = {
  query: ({ idApplicant, idTraining }) =>
    del({
      url: `${NX_REST_API}/trainings/module/saved_trainings/delete?applicantId=${idApplicant}&trainingId=${idTraining}`,
    }),
};

export const checkIfSavedTraining = {
  query: ({ idApplicant, idTraining }) =>
    get({
      url: `${NX_REST_API}/trainings/module/saved_trainings?applicantId=${idApplicant}&trainingId=${idTraining}`,
    }),
  format: ({ data }) => data,
};

export const checkIfPostuleTraining = {
  query: ({ idApplicant, idTraining }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications?applicantId=${idApplicant}&trainingId=${idTraining}`,
    }),
  format: ({ data }) => data,
};

export const savedOffer = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/jobs/module/saved_offers`,
      data,
    }),
};

export const postuleOffer = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/jobs/module/applications`,
      data,
    }),
};

export const unSavedOffer = {
  query: ({ idApplicant, idOffer }) =>
    del({
      url: `${NX_REST_API}/jobs/module/saved_offers/delete?applicantId=${idApplicant}&offerId=${idOffer}`,
    }),
};

export const checkIfSavedOffer = {
  query: ({ idApplicant, idOffer }) =>
    get({
      url: `${NX_REST_API}/jobs/module/saved_offers?applicantId=${idApplicant}&offerId=${idOffer}`,
    }),
  format: ({ data }) => data,
};

export const checkIfPostuleOffer = {
  query: ({ idApplicant, idOffer }) =>
    get({
      url: `${NX_REST_API}/jobs/module/applications?applicantId=${idApplicant}&offerId=${idOffer}`,
    }),
  format: ({ data }) => data,
};

export const getSavedCandidature = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/trainings/module/saved_trainings/applicant/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getPostuleCandidature = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/trainings/module/applications/applicant/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getSavedCandidatureEntreprise = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/jobs/module/saved_offers/applicant/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getPostuleCandidatureEntreprise = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/jobs/module/applications/applicant/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const setStatusSouscriptionTraining = {
  query: ({ id, status }) =>
    put({
      url: `${NX_REST_API}/trainings/module/subscriptions/${id}/set_status?active=${status}`,
    }),
};

export const setStatusSouscriptionOffer = {
  query: ({ id, status }) =>
    put({
      url: `${NX_REST_API}/jobs/module/subscriptions/${id}/set_status?active=${status}`,
    }),
};

export const getCountSouscriptionTraining = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/subscriptions/${id}/count`,
    }),
  format: ({ data }) => data,
};

export const getCountSouscriptionOffers = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/subscriptions/${id}/count`,
    }),
  format: ({ data }) => data,
};

export const getGoals = {
  query: () =>
    get({
      url: `${NX_REST_API}/individual/module/goals`,
    }),
  format: ({ data }) => data,
};

export const getStudentGoal = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/goals/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const setStudentGoal = {
  query: ({ id, idGoal }) =>
    put({
      url: `${NX_REST_API}/individual/module/goals/owner/${id}?goal=${idGoal}`,
    }),
};

export const getStudentDesiredContractLength = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/contractLength/${id}`,
    }),
  format: ({ data }) => data,
};

export const setStudentDesiredContractLength = {
  query: ({ id, length }) =>
    put({
      url: `${NX_REST_API}/individual/contractLength/${id}/?length=${length}`,
    }),
};

export const getStudentJobDomain = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/jobDomain/${id}`,
    }),
  format: ({ data }) => data,
};

export const setStudentJobDomain = {
  query: ({ id, domain }) =>
    put({
      url: `${NX_REST_API}/individual/jobDomain/${id}/?jobDomain=${domain}`,
    }),
};

export const getStudentJobSectors = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/jobs/${id}`,
    }),
  format: ({ data }) => data,
};

export const setStudentJobSectors = {
  query: ({ id, sectors }) =>
    put({
      url: `${NX_REST_API}/individual/module/jobs/${id}/?jobs=${sectors}`,
    }),
};

export const getStudentAffiliate = {
  query: ({ id, status, type }) =>
    get({
      url: `${NX_REST_API}/affiliates/student/${id}?status=${status}&type=${type}`,
    }),
};

export const setAffiliateAction = {
  query: ({ action, idAffiliate }) =>
    put({
      url: `${NX_REST_API}/affiliates/${idAffiliate}?action=${action}`,
    }),
};

export const getStudentInvitation = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/invites/${id}`,
    }),
  format: ({ data }) => data,
};

export const responseInvitationAffiliation = {
  query: ({ action, id }) =>
    put({
      url: `${NX_REST_API}/affiliates/invite/${id}/${action}`,
    }),
};

export const getInfoStudentDocument = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/documents/${id}`,
    }),
  format: ({ data }) => data,
};

export const getContractStudentData = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/individual/module/contract/${id}`,
    }),
  format: ({ data }) => data,
};

export const updateStudentContract = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/individual/module/contract/${id}`,
      data,
    }),
};

export const setClassroomMemberAction = {
  query: ({ action, id }) =>
    put({
      url: `${NX_REST_API}/affiliates/students/classroom_members/${id}?action=${action}`,
    }),
};

export const setTeamMemberAction = {
  query: ({ action, id }) =>
    put({
      url: `${NX_REST_API}/affiliates/students/team_members/${id}?action=${action}`,
    }),
};

export const getInfoStudentOnClassroom = {
  query: ({ idClassroom, idStudent }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/classroom_members?classroom=${idClassroom}&student=${idStudent}`,
    }),
  format: ({ data }) => data,
};

export const getInfoStudentOnTeam = {
  query: ({ idStudent, idTeam }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/team_members?team=${idTeam}&student=${idStudent}`,
    }),
  format: ({ data }) => data,
};

export const breakContract = {
  query: ({ actor, forEntity, id }) =>
    put({
      url: `${NX_REST_API}/affiliates/contracts/${id}/break?actor=${actor}&forEntity=${forEntity}`,
    }),
};

export const postStudentAbsence = {
  query: ({ studentId, classId, data }) =>
    post({
      url: `${NX_REST_API}/schools/module/absences/add/${studentId}/classroom/${classId}`,
      data
    }),
};

export const postAbsenceBusinessEmail = {
  query: ({ studentId, classId, data }) =>
    post({
      url: `${NX_REST_API}/schools/module/absences/email-absence/${classId}/${studentId}`,
      data
    }),
};

export const getBusinessEmailOfAStudentInAClassroom = {
  query: ({ studentId, classId }) =>
    get({
      url: `${NX_REST_API}/schools/module/absences/email-absence/${classId}/${studentId}`,
    }),
  format: ({ data }) => data,
};

export const getStudentClassroomPlanning = {
  query: ({ id, startDate, endDate }) => {
    const params = {
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
    };

    return get({
      url: `${NX_REST_API}/schools/module/planning/student/${id}`,
      options: {
        params,
      },
    });
  },
  format: ({ data }) => data,
};

export const getHolidays = {
  query: ({ }) =>
    get({
      url: `${NX_REST_API}/schools/module/planning/holiday`,
    }),
  format: ({ data }) => data,
}

export const getClassroomIdByUserId = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/student/${id}/classroom-id`
    }),
  format: ({ data }) => data,
}
export const getAbsenceHoursByStudentIdAndClassroomId = {
  query: ({ studentId, classId, type }) =>
    get({
      url: `${NX_REST_API}/schools/module/absences/${studentId}/classroom/${classId}/total-absence-hours${type ? `?type=${type}` : ""}`
    }),
  format: ({ data }) => data,
}

export const getAbsenceByStudentId = {
  query: ({ id, startDate, endDate }) =>
    get({
      url: `${NX_REST_API}/schools/module/absences/student/${id}${startDate ? `?startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}` : ""}`
    }),
  format: ({ data }) => data,
}

export const getAbsenceByStudentIds = {
  query: ({ studentIds, startDate, endDate }) =>
    get({
      url: `${NX_REST_API}/schools/module/absences/students${studentIds ? `?studentIds=${studentIds}` : ""}${startDate ? `&startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}` : ""}`
    }),
  format: ({ data }) => data,
}

export const getRemainingDays = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/module/classrooms/${id}/remaining-days`
    }),
  format: ({ data }) => data,
}

export const getPeriodByDate = {
  query: ({ id, date }) =>
    get({
      url: `${NX_REST_API}/schools/module/planning/classroom/${id}/period/date?date=${date}`
    }),
  format: ({ data }) => data,
}

export const getAbsencesSummaryByStudentId = {
  query: ({ id, from, to }) =>
    get({
      url: `${NX_REST_API}/schools/module/absences/by-student/${id}?from=${from}&to=${to}`
    }),
  format: ({ data }) => data,
}

// http://localhost:8080/jobs/module/offers/lba/apply
export const postApplyOfferLBA = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/jobs/module/offers/lba/apply`,
      data
    }),
}